import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const DentalCriteria4 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBooleanCheckboxFilterChange, getFilterBooleanCheckboxValue },
  } = useRootStore();

  const filterName = 'Orthodontics';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'ortho',
      label: 'Yes, I want child orthodontic coverage',
      value: 'ortho',
    },
    {
      id: 'ortho-all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Add Child Orthodontic Coverage"
        subtitle="Corrective orthodontia is a popular benefit. It covers braces for children up to age 19."
      />
      <RadioGroup
        label=""
        // ortho - is filterValue for which in filters object will be stored boolean value
        value={getFilterBooleanCheckboxValue(filterName, 'ortho')}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBooleanCheckboxFilterChange(filterName, e.target.value);
        }}
      />
    </div>
  );
});

export default withCriteria(DentalCriteria4, 4);
